import { DashboardStatusCard } from "@/components/DashboardStatusCard";
import { LayoutWithSidebar } from "@/components/LayoutWithSidebar";
import { McpServerList } from "@/components/McpServerList";
import { useWebSocketActions } from "@/providers/WebSocketProvider";

export default function DashboardPage() {
  // 从 WebSocketProvider 获取操作方法
  const { updateConfig } = useWebSocketActions();

  return (
    <LayoutWithSidebar title="看板">
      <div className="flex flex-1 flex-col">
        <div className="@container/main flex flex-1 flex-col gap-2">
          <div className="flex flex-col gap-4 py-4 md:gap-6 md:py-6">
            <DashboardStatusCard />
            <McpServerList updateConfig={updateConfig} />
          </div>
        </div>
      </div>
    </LayoutWithSidebar>
  );
}
